import { DashboardSubheadingInterface, StatementEntryInterface } from './Types';

const StatementEntry = (statementEntry: StatementEntryInterface) => {
  const { text = '', weight = '', color = '' } = statementEntry || {};

  return {
    text: String(text),
    emphasize: weight === 'bold',
    danger: color === 'red',
  };
};

const DashboardSubheading = (subheading: DashboardSubheadingInterface) => {
  const { title = '', statement = [] } = subheading || {};

  return {
    title: String(title),
    statement: statement.map((s) => StatementEntry(s)),
  };
};

export default DashboardSubheading;
